import React from "react";
import Menu from './Menu';
import './menu.css'

function App() {
	return (
		<div className="container">
			<Menu/>
		</div>
	);
}

export default App;
